export default [
  {
    name: "Home",
    title: "ERP",
    path: "/"
  },
  {
    name: "Stock",
    title: "库存",
    path: "/stock"
  },
  {
    name: "Yun",
    title: "云价格",
    path: "/yun"
  },
  {
    name: "Enquiry",
    title: "询价",
    path: "/enquiry"
  }
];
